// 強制隱藏購物車中的商品單價
(function() {
  'use strict';
  
  function hideCartItemPrices() {
    // 隱藏購物車頁面中的商品單價
    const cartItemDetails = document.querySelectorAll('.cart-item .cart-item__details');
    cartItemDetails.forEach(function(detail) {
      const priceElements = detail.querySelectorAll('.product-option, .price, .money, [class*="price"], [class*="money"]');
      priceElements.forEach(function(element) {
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.opacity = '0';
        element.style.height = '0';
        element.style.width = '0';
        element.style.overflow = 'hidden';
      });
    });
    
    // 隱藏購物車抽屜中的商品單價
    const cartDrawerDetails = document.querySelectorAll('#CartDrawer .cart-item .cart-item__details');
    cartDrawerDetails.forEach(function(detail) {
      const priceElements = detail.querySelectorAll('.product-option, .price, .money, [class*="price"], [class*="money"]');
      priceElements.forEach(function(element) {
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.opacity = '0';
        element.style.height = '0';
        element.style.width = '0';
        element.style.overflow = 'hidden';
      });
    });
  }
  
  // 頁面載入時執行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideCartItemPrices);
  } else {
    hideCartItemPrices();
  }
  
  // 監聽購物車更新事件
  document.addEventListener('cart:updated', hideCartItemPrices);
  document.addEventListener('cart:refresh', hideCartItemPrices);
  
  // 定期檢查並隱藏價格（防止動態添加的價格）
  setInterval(hideCartItemPrices, 1000);
  
  // 監聽 DOM 變化
  const observer = new MutationObserver(function(mutations) {
    let shouldHide = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldHide = true;
      }
    });
    if (shouldHide) {
      setTimeout(hideCartItemPrices, 100);
    }
  });
  
  // 開始監聽
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
